import $ from "jquery";
import Vimeo from "@vimeo/player";
import gsap from "gsap";

export default class videoPlayer {
  $el = null;
  video = null;
  $wrapper = null;
  player = null;
  $placeholder = null;

  constructor(el) {
    if (!el) {
      return false;
    }

    this.$el = el;
    this.video = $(this.$el).data("vimeo");
    this.$wrapper = $(this.$el).find(".player-wrapper");
    this.$placeholder = $(this.$el).find(".placeholder");
    this.$playBtn = $(this.$el).find(".play-button");

    this.$placeholder.on("click", () => {
      this.$playBtn.addClass("animate-pulse");

      this.setupPlayer();

      this.player.ready().then(() => {
        this.playVideo();
      });
    });
  }

  setupPlayer() {
    const options = {
      url: this.video,
      autoplay: false,
      controls: true,
      loop: true,
      muted: false,
    };

    this.player = new Vimeo(this.$el.find(".player"), options);
  }

  playVideo() {
    gsap.to(this.$placeholder, {
      duration: 0.5,
      opacity: 0,
      onComplete: () => {
        this.$placeholder.addClass("hidden");
      },
    });

    gsap.to(this.$wrapper, {
      duration: 0.5,
      perspective: 0,
      rotateY: 0,
    });

    this.player.play();
  }
}
